/** Dernière zone de chaque région = combat champion (HP ×1,2). */
export const CHAMPION_ZONE_ID = 13

/**
 * PV totaux d’un boss de zone — même formule que `spawnBoss` dans `useCombatLoop.ts`.
 * `zoneId` : identifiant de zone dans la région (1–13), comme `player.activeCombatZone`.
 */
export function computeZoneBossTotalHp(
  genId: number,
  zoneId: number,
  ascensionEnemyHpMult = 1,
): number {
  const localDiff = zoneId * 10
  const zoneIdx = zoneId - 1
  const smoothTeam = 2 + (zoneIdx / 12) * 4
  const championMult = zoneIdx === 12 ? 1.2 : 1.0
  const genDiffMult = 1 + (genId - 1) * (0.095 + 1.5 / localDiff)
  const bossGenMult =
    genId === 6 ? 1 + 3 * (0.095 + 1.5 / localDiff) : genDiffMult
  const hpMult = Math.max(1, ascensionEnemyHpMult)
  return Math.max(
    1,
    Math.round(
      smoothTeam * 170 * Math.pow(localDiff, 1.15) * bossGenMult * championMult * hpMult,
    ),
  )
}

/** DPS équipe (somme) minimum en moyenne pour finir avant la fin du timer (matchups neutres). */
export function zoneBossMinTeamDps(
  genId: number,
  zoneId: number,
  timerSeconds: number,
  ascensionEnemyHpMult = 1,
): number {
  return Math.ceil(
    computeZoneBossTotalHp(genId, zoneId, ascensionEnemyHpMult) / Math.max(1, timerSeconds),
  )
}

/** PV du champion régional (zone 13). */
export function computeChampionBossTotalHp(genId: number): number {
  return computeZoneBossTotalHp(genId, CHAMPION_ZONE_ID)
}

export function championMinTeamDps(genId: number, timerSeconds: number): number {
  return zoneBossMinTeamDps(genId, CHAMPION_ZONE_ID, timerSeconds)
}
